import { cleanAutocompleteText } from "./autocompleteOptions";

export const INDUSTRY_SELECTION_SEPARATOR = " | ";
const INDUSTRY_SELECTION_SPLIT_PATTERN = /\s*(?:\||,)\s*/g;

const cleanIndustryText = (value) => cleanAutocompleteText(value);
const isValidIndustrySelectionLabel = (value) => cleanIndustryText(value).length > 1;

const safeJsonParse = (value) => {
  if (typeof value !== "string") return null;
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};

const splitIndustrySelectionParts = (value) =>
  String(value ?? "")
    .split(INDUSTRY_SELECTION_SPLIT_PATTERN)
    .map((part) => cleanIndustryText(part))
    .filter(Boolean);

export const normalizeIndustrySelectionLabel = (value) => cleanIndustryText(value);

export const normalizeIndustrySelectionValues = (value, maxItems = 100) => {
  const seen = new Set();
  const next = [];

  const push = (item) => {
    const label = normalizeIndustrySelectionLabel(item);
    const key = label.toLowerCase();
    if (!isValidIndustrySelectionLabel(label) || seen.has(key)) return;
    seen.add(key);
    next.push(label);
  };

  const visit = (item) => {
    if (item == null) return;

    if (Array.isArray(item)) {
      item.forEach(visit);
      return;
    }

    if (item && typeof item === "object") {
      visit(
        item.label ??
          item.value ??
          item.name ??
          item.title ??
          item.industry ??
          item.industry_sector ??
          ""
      );
      return;
    }

    const cleaned = cleanIndustryText(item);
    if (!cleaned) return;

    const parsed = safeJsonParse(cleaned);
    if (Array.isArray(parsed)) {
      parsed.forEach(visit);
      return;
    }

    const splitParts = splitIndustrySelectionParts(cleaned);
    if (splitParts.length > 1) {
      splitParts.forEach(push);
      return;
    }

    push(cleaned);
  };

  visit(value);
  return next.slice(0, maxItems);
};

export const formatIndustrySelectionText = (value) =>
  normalizeIndustrySelectionValues(value).join(INDUSTRY_SELECTION_SEPARATOR);
